import { ITimeCategoryBaseDTO, ITimesheetAttachmentRequestDTO, ITimesheetTimeCategoryRequestDTO } from 'src/api/dtos';
import http from 'src/api/http';
import CommonRepository from 'src/api/repositories/common/common.repository';
import api from 'src/api/rtk/rtk-api';
import { IListQueryResult } from 'src/api/types';
import { getFileNameFromAxiosHeader } from 'src/shared/utils';

export default class CommonTimesheetRepository extends CommonRepository {
  private static readonly baseRoute = '/timesheets';
  private static readonly apiURL = this.setBaseUrl(this.baseURL, this.baseRoute);

  static uploadAttachment = async (payload: FormData): Promise<{ referenceId: string }> => {
    try {
      const { data } = await http.post(`${CommonTimesheetRepository.apiURL}/expenses/attachment`, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return data;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  static downloadAttachment = async ({
    referenceId,
  }: ITimesheetAttachmentRequestDTO): Promise<{ stream: Blob; fileName?: string }> => {
    try {
      const { data, headers } = await http.get(
        `${CommonTimesheetRepository.apiURL}/expenses/attachment/${referenceId}`,
        {
          responseType: 'blob',
        },
      );

      return {
        stream: data,
        fileName: getFileNameFromAxiosHeader(headers),
      };
    } catch (e) {
      return Promise.reject(e);
    }
  };

  static deleteAttachment = async ({ referenceId }: ITimesheetAttachmentRequestDTO): Promise<void> => {
    try {
      await http.delete(`${CommonTimesheetRepository.apiURL}/expenses/attachment/${referenceId}`);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public static endpoints = api.injectEndpoints({
    overrideExisting: true,
    endpoints: (build) => ({
      getTimeCategories: build.query<ITimeCategoryBaseDTO[], ITimesheetTimeCategoryRequestDTO>({
        query: (params) => ({ url: `${this.apiURL}/timecategories`, method: 'get', params }),
        transformResponse: (response: IListQueryResult<ITimeCategoryBaseDTO>) => response.items,
      }),
    }),
  });
}
